<template>
	<v-contextual-content v-if="$can('viewMode')" class="mode">
		<template v-slot:trigger="{ toggle }">
			<button
				class="badge--beta" @click="toggle"
				v-html="appMode"/>
		</template>
		<div class="mode__dropdown">
			<header>
				<h1 class="beta heavy">Select App Mode</h1>
			</header>
			<div>
				<dl>
					<div v-if="showMode('live')">
						<dt class="heavy mb-1">Live</dt>
						<dd>Lorem ipsum dolor sit amet…</dd>
						<dd class="mt-1">
							<button
								class="button button--primary button--small" @click.prevent="setMode('live')">Select
							</button>
						</dd>
					</div>
					<div v-if="showMode('demo')">
						<dt class="heavy mb-1">Demo</dt>
						<dd>Lorem ipsum dolor sit amet…</dd>
						<dd class="mt-1">
							<button
								class="button button--primary button--small" @click.prevent="setMode('demo')">Select
							</button>
						</dd>
					</div>
					<div v-if="showMode('test')">
						<dt class="heavy mb-1">Test</dt>
						<dd>Lorem ipsum dolor sit amet…</dd>
						<dd class="mt-1">
							<button
								class="button button--primary button--small" @click.prevent="setMode('test')">Select
							</button>
						</dd>
					</div>
				</dl>
			</div>
		</div>
	</v-contextual-content>
</template>
<script>
export default {
	computed: {
		appMode() {
			return this.$store.state.authStore.authed.appMode;
		},
		modeClass() {
			return "mode--" + this.appMode;
		},
		modeButtonStatus() {
			return this.testMode ? "Switch to Live Mode" : "Switch to Test Mode";
		},
		modes() {
			return ["live", "test", "demo"].filter(mode => mode !== this.appMode);
		},
	},
	methods: {
		showMode(mode) {
			return this.modes.indexOf(mode) > -1;
		},
		setMode(mode) {
			http().patch("switch-mode", {
				mode: mode,
			}).then((response) => {
				window.location = response.data.redirect;
			});
		},
	},
};
</script>
